import { HStack, Image, Stack, Text, VStack } from "@chakra-ui/react";
import {
  AttributeDefinitions,
  AttributeName,
  AttributeSelect,
  TreatmentType,
} from "@keita/lanepatrol-sdk";
import { AttributeUtils } from "../../../../coding/utils/attribute-utils";

interface Props {
  treatmentType: TreatmentType;
}
export const StmAttributeChange: React.FC<Props> = ({ treatmentType }) => {
  switch (treatmentType) {
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithLightSegregation:
      return (
        <>
          <OptionChange
            attributeName={AttributeName.FacilityType}
            optionIndex={3}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={AttributeName.LightSegregation}
            optionIndex={0}
          />
        </>
      );

    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane0To1m:
      return (
        <OptionChange
          attributeName={AttributeName.AdjacentFeatures0to1mRoadLane}
          optionIndex={1}
        />
      );
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane1To3m:
      return (
        <OptionChange
          attributeName={AttributeName.AdjacentFeatures1to3mRoadLane}
          optionIndex={1}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToACyclingPriorityStreet:
      return (
        <AttributeWithValue
          value="20 Km/h"
          attributeName={AttributeName.RoadOperatingSpeed}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToAMultiUsePath:
      return (
        <>
          <OptionChange
            attributeName={AttributeName.FacilityType}
            optionIndex={1}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={AttributeName.FacilityWidthPerDirection}
            optionIndex={1}
          />
        </>
      );

    case TreatmentType.UpgradeExistingFacilityToAnOffRoadBicyclePath:
      return (
        <OptionChange
          attributeName={AttributeName.FacilityType}
          optionIndex={2}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToAOneWayBicycleFacility:
      return (
        <OptionChange
          attributeName={AttributeName.FlowDirection}
          optionIndex={0}
        />
      );

    case TreatmentType.ImproveSurfaceConditions:
      return (
        <OptionChange
          attributeName={AttributeName.LooseOrSlipperySurface}
          optionIndex={1}
        />
      );

    case TreatmentType.InstallLightSegregation: {
      return (
        <OptionChange
          attributeName={AttributeName.LightSegregation}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.InstallLighting: {
      return (
        <OptionChange
          attributeName={AttributeName.StreetLighting}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ClearFacilityRemovedFixedObstacle: {
      return (
        <OptionChange
          attributeName={AttributeName.FixedObstacleOnFacility}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ClearFacilityRemovedNonFixedObstacles: {
      return (
        <OptionChange
          attributeName={AttributeName.NonFixedObstacleOnFacility}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ClearFacilityRemoveWidthRestriction: {
      return (
        <OptionChange
          attributeName={AttributeName.WidthRestriction}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ImproveFacilityAccess: {
      return (
        <OptionChange
          attributeName={AttributeName.FacilityAccess}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.RedesignTheCurve: {
      return (
        <OptionChange attributeName={AttributeName.Curvature} optionIndex={1} />
      );
    }

    case TreatmentType.WidenTheFacility: {
      return (
        <OptionChange
          attributeName={AttributeName.FacilityWidthPerDirection}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.InstallProtectiveBarrier:
      return (
        <>
          <OptionChange
            attributeName={AttributeName.AdjacentFeatures0to1mSevereHazard}
            optionIndex={1}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={AttributeName.AdjacentFeatures1to3mSevereHazard}
            optionIndex={1}
          />
        </>
      );

    case TreatmentType.ImproveDelineation: {
      return (
        <OptionChange
          attributeName={AttributeName.Delineation}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ReviewIntersectionApproach: {
      return (
        <OptionChange
          attributeName={AttributeName.IntersectionApproach}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ImproveSafetyOrCrossingDesign: {
      return (
        <OptionChange
          attributeName={AttributeName.CrossingFacility}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.EvaluateNeedForGradeSeparation: {
      return (
        <OptionChange
          attributeName={AttributeName.IntersectionOrRoadCrossing}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ReconfigureOrRemoveParking: {
      return (
        <OptionChange
          attributeName={AttributeName.AdjacentFeatures0to1mVehicleParking}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ReviewConfigurationOfTrainTramRails: {
      return (
        <OptionChange
          attributeName={AttributeName.TramOrTrainRails}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.InstallTrafficCalming: {
      return (
        <AttributeWithValue
          value="30 Km/h"
          attributeName={AttributeName.RoadOperatingSpeed}
        />
      );
    }

    case TreatmentType.VehiclesSpeedControl: {
      return (
        <HStack justifyContent="center" flexGrow={1}>
          <AttributeWithoutValue
            attributeName={AttributeName.RoadOperatingSpeed}
          />
          <Operation text="=" />
          <AttributeWithoutValue attributeName={AttributeName.RoadSpeedLimit} />
        </HStack>
      );
    }

    case TreatmentType.BicyclesSpeedControl: {
      return (
        <OptionChange
          attributeName={AttributeName.BicycleAndLVSpeedAverage}
          optionIndex={0}
        />
      );
    }

    default: {
      console.warn("StmAttributeChange: treatment not implemented.");
      return null;
    }
  }
};

const AttributeWithoutValue: React.FC<{
  attributeName: AttributeName;
}> = ({ attributeName }) => {
  const attributeDefinition = AttributeDefinitions.getByName(
    attributeName
  ) as AttributeSelect;
  const label = AttributeUtils.getLabel(attributeName);
  return (
    <VStack maxW="140px">
      <Image
        w="60px"
        title={label}
        alt={label}
        src={AttributeUtils.getImage(attributeDefinition, null)}
      />
      <Text
        fontSize="xs"
        fontWeight="bold"
        textTransform="uppercase"
        textAlign="center"
      >
        {label}
      </Text>
    </VStack>
  );
};

const AttributeWithValue: React.FC<{
  value: string;
  attributeName: AttributeName;
}> = ({ value, attributeName }) => {
  const attributeDefinition = AttributeDefinitions.getByName(
    attributeName
  ) as AttributeSelect;
  return (
    <HorizontalDisplay
      label={AttributeUtils.getLabel(attributeName)}
      value={value}
      imageSrc={AttributeUtils.getImage(attributeDefinition, null)}
    />
  );
};

const Operation: React.FC<{
  text: string;
}> = ({ text }) => {
  return (
    <Text fontSize="xs" fontWeight="bold">
      {text}
    </Text>
  );
};

const OptionChange: React.FC<{
  attributeName: AttributeName;
  optionIndex: number;
}> = ({ attributeName, optionIndex }) => {
  const attributeDefinition = AttributeDefinitions.getByName(attributeName)!;
  const option = (attributeDefinition as AttributeSelect).options[optionIndex];

  return (
    <HorizontalDisplay
      label={AttributeUtils.getLabel(attributeName)}
      value={AttributeUtils.getOptionLabel(option.value)}
      imageSrc={AttributeUtils.getImage(attributeDefinition, option.value)}
    />
  );
};

const HorizontalDisplay: React.FC<{
  value: string;
  label: string;
  imageSrc?: string;
}> = ({ value, imageSrc, label }) => {
  return (
    <HStack gap={0} flex={1} justifyContent="center">
      <Image w="60px" title={label} alt={label} src={imageSrc} />
      <Stack gap={0}>
        <Text
          fontSize="xs"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="center"
        >
          {label}
        </Text>
        <Text fontSize="sm">{value}</Text>
      </Stack>
    </HStack>
  );
};
